import type { LoginMethod } from '@zeus/index'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/components/ui/table'
import { useBranding } from '~/helpers/branding/branding-context'
import { DATE_TIME_WITH_YEAR, formatSessionDate } from '~/helpers/dates/session-dates'
import ProfileSection from './ProfileSection'

type ProfileLoginsProps = {
  events: { id: string, at: Date, method: LoginMethod }[]
  /** Le pied de tableau paginé, posé par qui charge les pages. */
  footer?: ReactNode
}

/** Les dernières connexions de l'apprenant (#242) : quand, et par quel moyen. */
function ProfileLogins({ events, footer }: ProfileLoginsProps) {
  const { t, i18n } = useTranslation()
  const { timezone } = useBranding()

  return (
    <ProfileSection title={t('profile.logins.title')} anchor="profile.logins">
      <p className="mb-3 text-xs text-muted-foreground">{t('profile.logins.retention')}</p>
      {events.length === 0
        ? <p className="text-sm text-muted-foreground">{t('profile.indicators.noLogin')}</p>
        : (
            <div className="rounded-md border">
              <Table aria-label={t('profile.logins.title')}>
                <TableHeader>
                  <TableRow>
                    <TableHead>{t('profile.logins.at')}</TableHead>
                    <TableHead>{t('profile.logins.method')}</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {events.map(event => (
                    <TableRow key={event.id}>
                      <TableCell>{formatSessionDate(event.at, i18n.language, timezone, DATE_TIME_WITH_YEAR)}</TableCell>
                      <TableCell>{t(`profile.logins.methods.${event.method}`)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
      {footer}
    </ProfileSection>
  )
}

export default ProfileLogins
